import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-emerald-400 to-emerald-600 rounded-xl flex items-center justify-center">
                <Zap className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold bg-gradient-to-r from-white to-emerald-400 bg-clip-text text-transparent">
                  Agami Cabs
                </h1>
                <p className="text-xs text-emerald-400 font-medium">You first, always</p>
              </div>
            </div>
            <p className="text-white/60 mb-4 max-w-md">
              Delhi NCR's premier electric cab service. Experience luxury, comfort, and eco-friendly transportation with professional chauffeurs and pristine vehicles.
            </p>
            <p className="text-white/40 text-sm">
              Available in Delhi, Gurgaon, and Noida
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Home
              </Link>
              <Link to="/about" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                About Us
              </Link>
              <a href="/#services" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Services
              </a>
              <a href="/#fleet" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Our Fleet
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <div className="space-y-2">
              <Link to="/terms" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Terms of Service
              </Link>
              <Link to="/privacy" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Privacy Policy
              </Link>
              <a href="#" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Refund Policy
              </a>
              <a href="#" className="block text-white/60 hover:text-emerald-400 transition-colors duration-300">
                Contact Support
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/40 text-sm">
            © 2024 Agami Cabs. All rights reserved. | Email: hello@agamicabs.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;